import { Client } from "@classes/camera/camera";



export class AuthUser {
    username: string;
    client: Client;
    clientId?: string;

    constructor(username: string, clientId?: string) {
        this.username = username;
        this.clientId = clientId;
    }

}
